export const inc = (x) => Number(x) + 1
